<template>
  <div class="site-diagnostic">
    <div class="panel diag-button">
      <el-button type="primary" 
        v-loading="!lightsLoaded"
        :disabled="!lightsLoaded"
        @click="showDialog">
        Site Diagnostic
      </el-button>
    </div>

    <div class="modal">
      <el-dialog 
        class="diag_modal" 
        title="Diagnostic" 
        :width="modalSize"
        :visible.sync="diagDialogVisible">

        <div class="btn-wrapper">
          <!-- <span v-if="!loading">Overall Status: <el-tag :type="siteStatusType">{{siteStatus}}</el-tag></span> -->
          <el-button type="save" size="small" @click="collapseAll">Collapse All</el-button>
        </div>
        

        <div 
        v-loading="loading"
        :element-loading-text="loadingMessage">

          <el-input
            class="treeFilter"
            placeholder="Filter keyword"
            v-model="filterText">
          </el-input>

          <el-tree 
            v-if="!reloading"
            :data="treeFormatted"
            :filter-node-method="filterNode"
            ref="tree"
            @node-click="handleNodeClick"
            :render-content="renderContent">
          </el-tree>

        </div>
      </el-dialog>
    </div>
    
  </div>
</template>

<script>

import requests from '../requests';

export default {
  props: ['fields', 'innerWidth'],
  data() {
    return {
      diagDialogVisible: false,
      testLogs: ['43 45 00', '4C 44 00 B2 B2 E8 E8 E8 E8 14 13 17 16 14 18 14 13 15'],
      testStatus: ['43 45 00', '4C 53 03 90 01 00 00 00 01 00 00 01 00 00'],
      fields: [],
      treeFormatted: [],
      loadingMessage: '',
      loading: false,
      reloading: false,
      filterText: '',
      modalSize: '75%',
      siteStatus: 'OK',
      siteStatusType: 'success', 
      renderedNodes: [],
      retrievedLogs: {},
      retrievedStatus: {},
      lightsLoaded: false,
    }
  },
  beforeMount(){
    this.lightsLoaded = false;

    if(this.fields.length > 0) {
      this.getLights();
    }

  },
  mounted() {
    
  },
  methods: {
    filterNode(value, data){
      if (!value) return true;
      return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    collapseAll() {
      this.reloading = true;
      this.$nextTick().then(()=>{
        this.reloading = false;
      })
    },
    getLights() {
      var context = this;
      var promises = [];

      for (var i = 0; i < this.fields.length; i++) {
        var n = i;
        promises.push(new Promise((resolve, reject) => {
          requests.getLightsAtField(context, context.fields[i].id, function (result) {
            if(result.data) {
              result.data.map(v => {v.mac = ('00:13:' + v.mac).slice(-23)})
              resolve(result.data);
            } else {
              resolve([]);
            }
          })
        }));
      }

      var context = this;
      Promise.all(promises).then((val) => {
        for (var i = 0; i < context.fields.length; i++) {
          context.fields[i].lights = val[i];
        }

        context.formatElTree();
      })
    },
    showDialog() {
      if(this.fields.length > 0) {
        this.getLights();
      }
      var context = this;
      context.siteStatus = 'OK'
      context.siteStatusType = 'success'
      context.diagDialogVisible = true
      context.loading = true

      var lightsWithZigbee = [];
      this.fields.map(v => lightsWithZigbee.push(...v.lights.filter(l => l.zigbee)));

      var uniqueIps = lightsWithZigbee.map(v => v.zigbee).filter((v, i, ar) => ar.indexOf(v) == i);

      if(!uniqueIps || !uniqueIps.length) {
        context.loadingMessage = 'No lights are configured for this site. Please contact support.'
      }

      uniqueIps.map(v => {
        var [ip, port] = v.split(':');

        context.loadingMessage = `Getting logs for ${v}`

        requests.getZigbeeLogs(this, ip, port, 'broadcast', function(result){
          context.loadingMessage = `Getting status for ${v}`

          if(result.action === 'success') {
            context.retrievedLogs = Object.assign(context.retrievedLogs, result.data);
            context.formatElTree();
          } else {
            context.$message({
              type: 'error',
              message: `Couldn't receive logs for ${v}`,
              showClose: true,
            })
          }

          requests.getZigbeeStatus(context, ip, port, 'broadcast', function(result){
            context.loadingMessage = 'Loaded'
            context.loading = false;

            if(result.action === 'success') {
              context.retrievedStatus = Object.assign(context.retrievedStatus, result.data);
              context.formatElTree();
            } else {
              context.$message({
                type: 'error',
                message: `Couldn't receive status for ${v}`,
                showClose: true,
              })
            }

            // After we've gotten (or not) all the logs and status
            // Map the parents
            context.treeFormatted.map(tf => context.setParents(tf));

            // Search for errors and warning
            // Highest priority ones should be first
            var foundEls = [];
            foundEls = foundEls.concat(context.findInTree('error', {type: 'danger', label: 'error'}));
            // foundEls = foundEls.concat(context.findInTree('CDRight: 116', {type: 'warning', label: 'warn'}));

            // Concat and flatten errors
            // [ [ [node, [node] ], [node] ], [ [node], [node] ] ] => [node, node, node, node, node]
            function recursiveConcat(arr) {
              return [].concat(...arr.map(v => {
                if(v instanceof Array) {
                  return [].concat(...recursiveConcat(v));
                } else {
                  return v;
                }
              }))
            }
            var els = recursiveConcat(foundEls);


            els.map(e => {
              // Add the issue tag to the problem value
              context.$set(e, 'tag', (<el-tag type={e.tagToAdd.type} size="mini">{e.tagToAdd.label}</el-tag>))

              // And every parent up its ancestor chain
              // if it doesn't already have a higher priority tag
              var p = e.parent;
              while(p) {
                if(!p.tag) {
                    context.$set(p, 'tag', (<el-tag type={e.tagToAdd.type} size="mini">{e.tagToAdd.label}</el-tag>))
                }
                p = p.parent;
              }
            })
          })
        })
      })

    },
    handleNodeClick(data) {
      // console.log(JSON.parse(JSON.stringify(data)));
    },
    renderContent(h, {node, data, store}) {
      return (
        <span>
          {data.tag}<span style="margin-left: 5px">{node.label}</span>
        </span>
      )
    },
    formatElTree() {
      //el-tree has stupid formatting.
      this.treeFormatted = this.fields.map((v) => {
        var d = {}
        d.label = v.field_name;

        if(v.lights.length == 0) {
          d.children = [{'label': 'No lights found.'}]
          return d
        }

        d.children = v.lights;

        for (var i = 0; i < d.children.length; i++) {
          var l = d.children[i];
          l.label = `${v.lights[i].num}: ${v.lights[i].mac}`;
          if(v.lights[i].nickname) {
            l.label += ` (${v.lights[i].nickname})`
          }
          l.children = [{
            label: 'Logs',
            children: []
          },{
            label: 'Status',
            children: []
          }];
          
          if(this.retrievedLogs.hasOwnProperty(v.lights[i].mac)) {
            l.children[0].children = this.formatObjToTree(this.dataParser(this.retrievedLogs[v.lights[i].mac]))
          } else {
            if(Math.random() > 0.5)
              l.children[0].label = "Error: No logs retrieved."
            else
              l.children[0].children = this.formatObjToTree(this.dataParser(this.testLogs));
          }

          if(this.retrievedStatus.hasOwnProperty(v.lights[i].mac)) {
            l.children[1].children = this.formatObjToTree(this.dataParser(this.retrievedStatus[v.lights[i].mac]))
          } else {
            if(Math.random() > 0.5)
              l.children[1].label = "Error: No status retrieved."
            else
              l.children[1].children = this.formatObjToTree(this.dataParser(this.testStatus));
          }
        }

        return d;
      })

      this.lightsLoaded = true;
    },
    formatObjToTree(o) {
      //I hate this so much
      //It's completely unreadable, (and used to be worse) but I can't think of a better way
      //Basically, change {'foo': {'bar': 'baz'}} into 
      //                  {'label': 'foo', 'children':[{'label': 'bar: baz'}]}
      //The el-tree data structure is dumb
      var outArr = [];
      if(o instanceof Array) {
        // console.log(o)
        for (var i = 0; i < o.length; i++) {
          for (var k in o[i]) {
            if (o[i].hasOwnProperty(k)) {
              outArr.push({'label': `${k}: ${o[i][k]}`});              
            }
          }
        }
      } else {
        // console.log(o)
        for (var k in o) {
          if (o.hasOwnProperty(k)) {
            var e = o[k];
            outArr.push({'label': k, 'children':[]})
            if(typeof(e) === 'object') {

              for (var k2 in e) {
                if(e.hasOwnProperty(k2)) {
                  outArr[outArr.length-1].children.push({'label': `${k2}: ${e[k2]}`}); //, 'children': [{'label':e[k2]}]});
                }
              }
            } else {
              outArr[outArr.length-1].label = `${k}: ${e}`
            }
          }
        }
      }
      return outArr;
    },
    setParents(element) {
      if(element.children && element.children.length){
        element.children.map(c => {
          this.setParents(c);
          c.parent = element;
        });
      }
    },
    dataParser(data) {
      if(data.length > 1) {
        var header = data[0];
        data = data[1].split(' ');
      } else {
        return {'Error': 'Malformed data.'}
      }

      //Convert all codes (except the status) to dec
      data = [data[0], data[1]].concat(
        data.slice(2).map(v => parseInt(v, 16))
      )

      if(data[0] === '4C' && data[1] === '44') { // 4C 44 => GL => Get Logs
   
        var d = {
          // type: 'Get Logs', //data[0],
          // codes: [ String.fromCharCode(data[1]), String.fromCharCode(data[2]), data[3] ],
          iLower: data[3]*200, 
          iUpper: data[4]*200,
          Voltage: {
            ABLeft: data[5]/2,
            ABRight: data[6]/2,
            CDLeft: data[7]/2,
            CDRight: data[8]/2,
          },
          Temp: {
            ARight: data[9]+'°C',
            ALeft: data[10]+'°C',
            BRight: data[11]+'°C',
            BLeft: data[12]+'°C',
            CRight: data[13]+'°C',
            CLeft: data[14]+'°C',
            DRight: data[15]+'°C',
            DLeft: data[16]+'°C',
            Driver: data[17]+'°C',
          }
        }

      } else if (data[0] === '4C' && data[1] === '53') { //4C 53 => GS => Get Status
        var d = [
            {'normal': data[4]},
            {'w7': data[5]},
            {'w8': data[6]},
            {'w9': data[7]},
            {'lower': data[8]},
            {'w11': data[9]},
            {'w12': data[10]},
            {'upper': data[11]},
            {'w14': data[12]},
            {'w15': data[13]},
          ]
      }

      return d
    },
    treeTraversal(element, searchLabel, tag) {
      tag = tag || '';

      if(!element.label) return false;

      if(new RegExp(searchLabel.toLowerCase()).test(element.label.toLowerCase())) {
        return element;
      }

      if(element.children && element.children.length) {
        var foundEls = element.children.map(e => {
          var el = this.treeTraversal(e, searchLabel, tag);
          if(el){
            el.tagToAdd = tag;
          }
          return el
        }).filter(v => !!v);

        if(foundEls && foundEls.length) {
          return foundEls;
        }

      }

      return false;
    },
    findInTree(searchLabel, tag) {
      var foundEls = [];
      var found = null;

      this.treeFormatted.map(tf => {
        found = this.treeTraversal(tf, searchLabel, tag);
        if(found){
          found.tagToAdd = tag;
          foundEls.push(found);
        }
      })

      return foundEls;
    },
  },
  watch: {
    filterText(val){
      this.$refs.tree.filter(val);
    },
    fields(val) {
      if(val && val.length) {
        this.getLights();
      }
    },
    innerWidth(val){
      if(val < 600) {
        this.modalSize = '100%';
      } else {
        this.modalSize = '75%';
      }
    }
  }

}
</script>

<style>

.el-tree {
  text-align: left;
}

.treeFilter {
  padding: 16px 0px;
}

</style>



// WEBPACK FOOTER //
// SiteDiagnostic.vue?bf67641c